import React, { useEffect, useState, useRef } from "react"
import { Col, Container, Modal, Row, Table, Button, Form, Tab, Tabs } from "react-bootstrap"
import style from "./ManuscriptSubmission.module.scss"
import { useHistory, useParams } from "react-router-dom";
import AxiosService from "../../../../utils/AxiosService";
import classNames from "classnames";
import { CircleLoader } from "../../../../components/Loader/CommonLoader";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faDownload, faTrash, faUpload, faXmark, faFileAlt, faCheck, faExclamationTriangle, faSpinner, faRotateRight, faBan } from "@fortawesome/free-solid-svg-icons";
import { useDropzone } from 'react-dropzone';
import fileDownload from "js-file-download";
import TooltipButton from "../../../../components/TooltipButton/TooltipButton";

const SimplifiedManuscriptSubmission = (props) => { 
	const {manuscriptId} = useParams();
	const MAX_FILES_PER_BATCH = 50;
	const [journal, setJournal] = useState();
	const apiService = new AxiosService();
	const history = useHistory();
	const [journalloader, setJournalLoader] = useState(false)
	const [journalGuidelines, setJournalGuidelines] = useState();
	const [journalDetails, setJournalDetails] = useState()
	const [show, setShow] = useState(false);
	const [key, setKey] = useState(0)
	
	// File management state
	const [files, setFiles] = useState([]);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [loading, setLoading] = useState({
		upload: false,
		validate: false,
		delete: false,
		deleteMultiple: false,
		downloadError: false,
		fetchFiles: false
	});
	const [deleteConfirmModal, setDeleteConfirmModal] = useState({
		visible: false,
		fileId: null,
		fileName: '',
		isMultiple: false,
		fileList: []
	});
	const inputFile = useRef(null);
	const [manuscriptTitle, setManuscriptTitle] = useState("");
	const prevFilesEmptyRef = useRef(true);
	
	// Upload progress modal state
	const [uploadProgress, setUploadProgress] = useState({
		visible: false,
		files: [] // Array of {id, name, status, error, abortController}
	});
	
	// Delete progress modal state
	const [deleteProgress, setDeleteProgress] = useState({
		visible: false,
		files: [] // Array of {id, fileId, name, status, error}
	});
	
	// Max files warning modal state
	const [maxFilesWarningModal, setMaxFilesWarningModal] = useState({
		visible: false,
		message: ''
	});
	
	// API call to get uploaded files
	const getStepTwoFiles = () => {
		console.log('🔄 Calling getStepTwoFiles API for manuscriptId:', manuscriptId);
		setLoading(prev => ({ ...prev, fetchFiles: true }));
		
		apiService.getStepTwoFiles(manuscriptId).then(res => {
			console.log('✅ getStepTwoFiles API Response:', res);
			console.log('📁 Files data:', res.result);
			
			setLoading(prev => ({ ...prev, fetchFiles: false }));
			
			// Transform API response to match component expectations
			const transformedFiles = res.result?.map(file => ({
				id: file.fileId,
				fileId: file.fileId,
				name: file.fileName,
				fileName: file.fileName,
				size: 0, // Not provided by API
				type: getFileTypeFromName(file.fileName),
				validationType: file.type || null,
				uploadDate: new Date().toISOString(), // Not provided by API
				status: 'uploaded', // Default status
				errorCount: 0, // Default value
				warningCount: 0, // Default value
				reports: file.reports,
				message: file.message || 'Uploaded' // Add message field from API
			})) || [];
			
			setFiles(transformedFiles);
			
			// If previous file list was empty and now there are files, select all by default
			if (prevFilesEmptyRef.current && transformedFiles.length > 0) {
				setSelectedFiles(transformedFiles.map(f => f.fileId));
			}
			// Update the ref for next time
			prevFilesEmptyRef.current = transformedFiles.length === 0;
			
		}).catch(err => {
			console.error('❌ getStepTwoFiles API Error:', err);
			console.error('Error details:', err?.response?.data);
			
			setLoading(prev => ({ ...prev, fetchFiles: false }));
			toast.error(err?.response?.data?.message || "Failed to fetch files", { autoClose: 3000 });
			
			// Set empty array on error
			setFiles([]);
			prevFilesEmptyRef.current = true;
		});
	}

	// Helper function to determine file type from file name
	const getFileTypeFromName = (fileName) => {
		const extension = fileName.toLowerCase().split('.').pop();
		switch (extension) {
			case 'docx':
				return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			case 'pdf':
				return 'application/pdf';
			case 'zip':
				return 'application/zip';
			default:
				return 'application/octet-stream';
		}
	}

	// Function to trigger file list refresh (to be called when files change)
	const refreshFileList = () => {
		console.log('🔄 Refreshing file list...');
		getStepTwoFiles();
	}

	const getManuscriptTitle = () => {
		apiService.getStepOneDetails(manuscriptId).then(res => {
			setManuscriptTitle(res.result?.manuscriptTitle || "Untitled Manuscript");
		}).catch(e => {
			setManuscriptTitle("Untitled Manuscript");
		});
	};

	const getJournalInfo = () => {
		apiService.getJournalTitle(manuscriptId).then(res => {
			if (res.result) {
				setJournal(res.result);
			}
		}).catch(e => {
			console.error('Failed to get journal info:', e);
		});
	};

	const handleGuidelines = () => {
		setShow(true);
		setJournalLoader(true);
		apiService.getJournalDetails(journal.journalId).then((res) => {
			setJournalDetails(res.data.data)
			apiService.getJournalGuidelines(journal.journalId, manuscriptId).then(res=>{
				setJournalLoader(false)
				let array = []
				Object.keys(res.result).forEach(key=>{
					if(res.result[key].length > 0){
						array.push({
							name: key,
							data: res.result[key]
						})
					}
				})
				setJournalGuidelines(array)
			}).catch(err=> {
				setJournalLoader(false)
				toast.error(err.response.data.message,  {
					autoClose: 3000,
				})
			})
		}).catch(err => {
			setJournalLoader(false)
			toast.error(err.response.data.message,  {
				autoClose: 3000,
			})
		})
	}

	const onDrop = React.useCallback((acceptedFiles) => {
		if (!loading.upload && !loading.validate && !loading.downloadError && !loading.deleteMultiple) {
			// Check if adding files would exceed the limit
			if (files.length + acceptedFiles.length > MAX_FILES_PER_BATCH) {
				const remainingSlots = MAX_FILES_PER_BATCH - files.length;
				setMaxFilesWarningModal({
					visible: true,
					message: `You can only upload ${remainingSlots} more file(s). Current: ${files.length} files, Attempting: ${acceptedFiles.length} files, Maximum: ${MAX_FILES_PER_BATCH} files per batch.`
				});
				return;
			}
			
			// Single file: use existing toast-based upload
			if (acceptedFiles.length === 1) {
				handleFileUpload(acceptedFiles);
			} 
			// Multiple files: use modal-based upload
			else if (acceptedFiles.length > 1) {
				handleMultipleFileUpload(acceptedFiles);
			}
		}
	}, [loading.upload, loading.validate, loading.downloadError, loading.deleteMultiple, files.length]);

	// Dropzone and file input setup
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		onDropRejected: (fileRejections) => {
			fileRejections.forEach((fileRejection) => {
				fileRejection.errors.forEach((error) => {
				if (error.code === 'file-invalid-type') {
					toast.error("Only DOCX, PDF, or ZIP files are allowed.", { autoClose: 3000 });
				}
				});
			});
		},
		multiple: true, // Allow multiple files
		accept: {
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
			'application/pdf': ['.pdf'],
			'application/zip': ['.zip']
		}
	});

	const handleFileUpload = async (fileList) => {
		if (loading.validate || loading.downloadError || loading.deleteMultiple) {
			toast.warning("Please wait for current operation to complete before uploading new files", {
				autoClose: 3000,
			});
			return;
		}
		
		// Check if adding files would exceed the limit
		if (files.length >= MAX_FILES_PER_BATCH) {
			setMaxFilesWarningModal({
				visible: true,
				message: `Maximum ${MAX_FILES_PER_BATCH} files allowed per batch. Please delete some files before uploading more.`
			});
			return;
		}
		
		if (fileList.length > 1) {
			toast.error("Only one file can be uploaded at a time.", { autoClose: 3000 });
			return;
		}
		const file = fileList[0];
		const allowedTypes = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/zip'];
		if (!allowedTypes.includes(file.type) && !['.docx', '.pdf', '.zip'].some(ext => file.name.toLowerCase().endsWith(ext))) {
			toast.error("Only DOCX, PDF, or ZIP files are allowed.", { autoClose: 3000 });
			return;
		}
		setLoading({...loading, upload: true});
		try {
			const formData = new FormData();
			formData.append("file", file);
			await apiService.uploadStepTwoFile(manuscriptId, formData);
			setLoading({...loading, upload: false});
			toast.success(
				file.name.toLowerCase().endsWith('.zip')
					? "ZIP file uploaded successfully - contents will be processed"
					: "File uploaded successfully",
				{ autoClose: 3000 }
			);
			refreshFileList();
		} catch (error) {
			setLoading({...loading, upload: false});
			toast.error(error?.response?.data?.message || "Failed to upload file", { autoClose: 3000 });
		}
	};

	// Helper function to upload a single file with abort support
	const uploadSingleFile = async (file, abortController) => {
		const formData = new FormData();
		formData.append("file", file);
		
		return apiService.uploadStepTwoFile(manuscriptId, formData, {
			signal: abortController.signal
		});
	};

	// Handle multiple file upload with progress modal
	const handleMultipleFileUpload = async (fileList) => {
		if (loading.validate || loading.downloadError || loading.deleteMultiple) {
			toast.warning("Please wait for current operation to complete before uploading new files", {
				autoClose: 3000,
			});
			return;
		}

		// Check if adding files would exceed the limit
		if (files.length + fileList.length > MAX_FILES_PER_BATCH) {
			const remainingSlots = MAX_FILES_PER_BATCH - files.length;
			setMaxFilesWarningModal({
				visible: true,
				message: `You can only upload ${remainingSlots} more file(s). Current: ${files.length} files, Attempting: ${fileList.length} files, Maximum: ${MAX_FILES_PER_BATCH} files per batch.`
			});
			return;
		}

		// Validate all files first
		const allowedTypes = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/zip'];
		const invalidFiles = fileList.filter(file => 
			!allowedTypes.includes(file.type) && 
			!['.docx', '.pdf', '.zip'].some(ext => file.name.toLowerCase().endsWith(ext))
		);

		if (invalidFiles.length > 0) {
			toast.error("Only DOCX, PDF, or ZIP files are allowed.", { autoClose: 3000 });
			return;
		}

		// Initialize upload progress state
		const uploadFiles = fileList.map((file, index) => ({
			id: `upload_${Date.now()}_${index}`,
			name: file.name,
			file: file,
			status: 'pending',
			error: null,
			abortController: new AbortController()
		}));

		setUploadProgress({
			visible: true,
			files: uploadFiles
		});

		setLoading({...loading, upload: true});

		// Process files sequentially
		for (let i = 0; i < uploadFiles.length; i++) {
			const uploadFile = uploadFiles[i];
			
			// Skip if cancelled
			if (uploadFile.status === 'cancelled') {
				continue;
			}

			// Update status to uploading
			setUploadProgress(prev => ({
				...prev,
				files: prev.files.map(f => 
					f.id === uploadFile.id ? { ...f, status: 'uploading' } : f
				)
			}));

			try {
				await uploadSingleFile(uploadFile.file, uploadFile.abortController);
				
				// Update status to success
				setUploadProgress(prev => ({
					...prev,
					files: prev.files.map(f => 
						f.id === uploadFile.id ? { ...f, status: 'success' } : f
					)
				}));
			} catch (error) {
				if (error.name === 'AbortError') {
					// File was cancelled
					setUploadProgress(prev => ({
						...prev,
						files: prev.files.map(f => 
							f.id === uploadFile.id ? { ...f, status: 'cancelled' } : f
						)
					}));
				} else {
					// Upload failed
					setUploadProgress(prev => ({
						...prev,
						files: prev.files.map(f => 
							f.id === uploadFile.id ? { 
								...f, 
								status: 'failed', 
								error: error?.response?.data?.message || 'Upload failed' 
							} : f
						)
					}));
				}
			}
		}

		setLoading({...loading, upload: false});
		
		// Refresh file list after all uploads complete
		refreshFileList();
	};

	// Retry single failed file
	const handleRetryFile = async (fileId) => {
		const uploadFile = uploadProgress.files.find(f => f.id === fileId);
		if (!uploadFile) return;

		// Create new abort controller for retry
		const newAbortController = new AbortController();
		
		setUploadProgress(prev => ({
			...prev,
			files: prev.files.map(f => 
				f.id === fileId ? { 
					...f, 
					status: 'uploading', 
					error: null, 
					abortController: newAbortController 
				} : f
			)
		}));

		try {
			await uploadSingleFile(uploadFile.file, newAbortController);
			
			setUploadProgress(prev => ({
				...prev,
				files: prev.files.map(f => 
					f.id === fileId ? { ...f, status: 'success' } : f
				)
			}));
			
			// Refresh file list after successful retry
			refreshFileList();
		} catch (error) {
			if (error.name !== 'AbortError') {
				setUploadProgress(prev => ({
					...prev,
					files: prev.files.map(f => 
						f.id === fileId ? { 
							...f, 
							status: 'failed', 
							error: error?.response?.data?.message || 'Upload failed' 
						} : f
					)
				}));
			}
		}
	};

	// Retry all failed files
	const handleRetryAllFailed = async () => {
		const failedFiles = uploadProgress.files.filter(f => f.status === 'failed');
		
		for (const failedFile of failedFiles) {
			await handleRetryFile(failedFile.id);
		}
	};

	// Cancel individual file upload
	const handleCancelFile = (fileId) => {
		setUploadProgress(prev => ({
			...prev,
			files: prev.files.map(f => {
				if (f.id === fileId && f.status === 'uploading') {
					f.abortController.abort();
					return { ...f, status: 'cancelled' };
				}
				return f;
			})
		}));
	};

	// Cancel all pending/uploading files
	const handleCancelAllPending = () => {
		setUploadProgress(prev => ({
			...prev,
			files: prev.files.map(f => {
				if ((f.status === 'pending' || f.status === 'uploading') && f.abortController) {
					f.abortController.abort();
					return { ...f, status: 'cancelled' };
				}
				return f;
			})
		}));
	};

	// Close upload progress modal
	const handleCloseUploadModal = () => {
		const allComplete = uploadProgress.files.every(f => 
			f.status === 'success' || f.status === 'failed' || f.status === 'cancelled'
		);
		
		if (allComplete) {
			setUploadProgress({ visible: false, files: [] });
			
			// Show summary toast
			const successCount = uploadProgress.files.filter(f => f.status === 'success').length;
			const failedCount = uploadProgress.files.filter(f => f.status === 'failed').length;
			const cancelledCount = uploadProgress.files.filter(f => f.status === 'cancelled').length;
			
			if (successCount > 0) {
				toast.success(`${successCount} file(s) uploaded successfully`, { autoClose: 3000 });
			}
			if (failedCount > 0) {
				toast.error(`${failedCount} file(s) failed to upload`, { autoClose: 3000 });
			}
			if (cancelledCount > 0) {
				toast.warning(`${cancelledCount} file(s) were cancelled`, { autoClose: 3000 });
			}
		}
	};

	const handleFileSelection = (fileId) => {
		setSelectedFiles(prev => {
			if (prev.includes(fileId)) {
				return prev.filter(id => id !== fileId);
			} else {
				return [...prev, fileId];
			}
		});
	};

	const handleSelectAll = () => {
		if (selectedFiles.length === files.length) {
			setSelectedFiles([]);
		} else {
			setSelectedFiles(files.map(file => file.fileId));
		}
	};

	const handleValidateSelected = () => {
		if (selectedFiles.length === 0) {
			toast.warning("Please select files to validate", {
				autoClose: 3000,
			});
			return;
		}

		setLoading({...loading, validate: true});
		
		const requestBody = {
			"files": selectedFiles
		};
		
		apiService.validateFiles(manuscriptId, requestBody).then(res => {
			setLoading({...loading, validate: false});
			
			// Refresh file list to get updated validation status
			refreshFileList();
		}).catch(err => {
			setLoading({...loading, validate: false});
			toast.error(err?.response?.data?.message || "File validation failed", {
				autoClose: 3000,
			});
		});
	};

	const handleDeleteFile = (fileId) => {
		const file = files.find(f => f.fileId === fileId);
		setDeleteConfirmModal({
			visible: true,
			fileId: fileId,
			fileName: file.fileName,
			isMultiple: false,
			fileList: []
		});
	};

	const handleDeleteSelectedFiles = () => {
		if (selectedFiles.length === 0) {
			toast.warning("Please select files to delete", {
				autoClose: 3000,
			});
			return;
		}

		if (loading.deleteMultiple || loading.validate || loading.downloadError) {
			toast.warning("Please wait for current operation to complete before deleting files", {
				autoClose: 3000,
			});
			return;
		}

		const filesToDelete = files.filter(f => selectedFiles.includes(f.fileId));
		setDeleteConfirmModal({
			visible: true,
			fileId: null,
			fileName: '',
			isMultiple: true,
			fileList: filesToDelete
		});
	};

	const confirmDeleteFile = () => {
		if (deleteConfirmModal.isMultiple) {
			// Handle multiple file deletion
			executeDeleteBatch(deleteConfirmModal.fileList);
		} else {
			// Handle single file deletion (existing logic)
			setLoading({...loading, delete: true});
			
			const body = {
				"fileId": deleteConfirmModal.fileId
			};
			
			apiService.deleteFile(manuscriptId, body).then(res => {
				setLoading({...loading, delete: false});
				setDeleteConfirmModal({visible: false, fileId: null, fileName: '', isMultiple: false, fileList: []});
				setSelectedFiles(prev => prev.filter(id => id !== deleteConfirmModal.fileId));
				toast.success(res.result || "File deleted successfully", {
					autoClose: 3000,
				});
				
				// Refresh file list from API after deletion
				refreshFileList();
			}).catch(err => {
				console.log("Error in file delete:", err?.response);
				setLoading({...loading, delete: false});
				toast.error(err?.response?.data?.message || "Failed to delete file", {
					autoClose: 3000,
				});
			});
		}
	};

	const executeDeleteBatch = async (filesToDelete) => {
		// Close confirmation modal
		setDeleteConfirmModal({visible: false, fileId: null, fileName: '', isMultiple: false, fileList: []});
		
		// Initialize delete progress state
		const deleteFiles = filesToDelete.map((file, index) => ({
			id: `delete_${Date.now()}_${index}`,
			fileId: file.fileId,
			name: file.fileName,
			status: 'pending',
			error: null
		}));

		setDeleteProgress({
			visible: true,
			files: deleteFiles
		});

		setLoading({...loading, deleteMultiple: true});

		// Process deletions sequentially
		for (let i = 0; i < deleteFiles.length; i++) {
			const deleteFile = deleteFiles[i];
			
			// Skip if cancelled
			if (deleteFile.status === 'cancelled') {
				continue;
			}

			// Update status to deleting
			setDeleteProgress(prev => ({
				...prev,
				files: prev.files.map(f => 
					f.id === deleteFile.id ? { ...f, status: 'deleting' } : f
				)
			}));

			try {
				const body = { "fileId": deleteFile.fileId };
				await apiService.deleteFile(manuscriptId, body);
				
				// Update status to success
				setDeleteProgress(prev => ({
					...prev,
					files: prev.files.map(f => 
						f.id === deleteFile.id ? { ...f, status: 'success' } : f
					)
				}));
			} catch (error) {
				// Delete failed
				setDeleteProgress(prev => ({
					...prev,
					files: prev.files.map(f => 
						f.id === deleteFile.id ? { 
							...f, 
							status: 'failed', 
							error: error?.response?.data?.message || 'Delete failed' 
						} : f
					)
				}));
			}
		}

		setLoading({...loading, deleteMultiple: false});
		
		// Refresh file list after all deletions complete
		refreshFileList();
	};

	// Retry single failed deletion
	const handleRetryDeleteFile = async (fileId) => {
		const deleteFile = deleteProgress.files.find(f => f.id === fileId);
		if (!deleteFile) return;

		setDeleteProgress(prev => ({
			...prev,
			files: prev.files.map(f => 
				f.id === fileId ? { 
					...f, 
					status: 'deleting', 
					error: null 
				} : f
			)
		}));

		try {
			const body = { "fileId": deleteFile.fileId };
			await apiService.deleteFile(manuscriptId, body);
			
			setDeleteProgress(prev => ({
				...prev,
				files: prev.files.map(f => 
					f.id === fileId ? { ...f, status: 'success' } : f
				)
			}));
			
			// Refresh file list after successful retry
			refreshFileList();
		} catch (error) {
			setDeleteProgress(prev => ({
				...prev,
				files: prev.files.map(f => 
					f.id === fileId ? { 
						...f, 
						status: 'failed', 
						error: error?.response?.data?.message || 'Delete failed' 
					} : f
				)
			}));
		}
	};

	// Retry all failed deletions
	const handleRetryAllFailedDeletes = async () => {
		const failedFiles = deleteProgress.files.filter(f => f.status === 'failed');
		
		for (const failedFile of failedFiles) {
			await handleRetryDeleteFile(failedFile.id);
		}
	};

	// Close delete progress modal
	const handleCloseDeleteModal = () => {
		const allComplete = deleteProgress.files.every(f => 
			f.status === 'success' || f.status === 'failed' || f.status === 'cancelled'
		);
		
		if (allComplete) {
			setDeleteProgress({ visible: false, files: [] });
			
			// Show summary toast
			const successCount = deleteProgress.files.filter(f => f.status === 'success').length;
			const failedCount = deleteProgress.files.filter(f => f.status === 'failed').length;
			
			if (successCount > 0) {
				toast.success(`${successCount} file(s) deleted successfully`, { autoClose: 3000 });
			}
			if (failedCount > 0) {
				toast.error(`${failedCount} file(s) failed to delete`, { autoClose: 3000 });
			}
			
			// Clear successfully deleted files from selection
			const successfulFileIds = deleteProgress.files
				.filter(f => f.status === 'success')
				.map(f => f.fileId);
			setSelectedFiles(prev => prev.filter(id => !successfulFileIds.includes(id)));
		}
	};

	const handleDownloadFileReport = (fileId) => {
		const file = files.find(f => f.fileId === fileId);
		setLoading({...loading, downloadError: true});
		
		// Simulate individual file error report download
		setTimeout(() => {
			const dummyContent = `Validation Error Report for: ${file.fileName}\n======================================\n\nFile: ${file.fileName}\nStatus: ${file.status}\nErrors: ${file.errorCount}\nWarnings: ${file.warningCount}\n\nThis is a dummy error report for the individual file.`;
			const blob = new Blob([dummyContent], { type: 'text/plain' });
			fileDownload(blob, `${file.fileName}_error_report.txt`);
			setLoading({...loading, downloadError: false});
			toast.success(`Error report downloaded for ${file.fileName}`, {
				autoClose: 3000,
			});
		}, 1000);
	};

	// Helper function to sanitize batch name for use in filename
	// Removes or replaces invalid filename characters
	const sanitizeBatchNameForFilename = (batchName) => {
		if (!batchName || batchName.trim() === '') {
			return 'Untitled';
		}
		
		// Replace invalid filename characters with underscore
		// Invalid chars: < > : " / \ | ? * and control characters
		// Note: Spaces are kept as they are valid in filenames
		let sanitized = batchName
			.replace(/[<>:"/\\|?*\x00-\x1F]/g, '_') // Replace invalid chars with underscore
			.replace(/\s+/g, ' ') // Collapse multiple spaces to single space
			.trim(); // Remove leading/trailing whitespace
		
		// Limit length to avoid filesystem issues (max 255 chars for filename, leave room for "_Report.xlsx")
		if (sanitized.length > 200) {
			sanitized = sanitized.substring(0, 200).trim();
		}
		
		return sanitized || 'Untitled';
	};

	// Helper function to extract filename from Content-Disposition header
	// TODO: This will be used once backend adds Access-Control-Expose-Headers: Content-Disposition
	const extractFilenameFromContentDisposition = (contentDisposition) => {
		if (!contentDisposition) {
			return null; // Return null when header is not available
		}

		// Content-Disposition format: attachment; filename="filename.xlsx" or attachment; filename=filename.xlsx
		const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
		
		if (filenameMatch && filenameMatch[1]) {
			// Remove quotes if present
			let filename = filenameMatch[1].replace(/['"]/g, '');
			
			// Decode URI if needed
			try {
				filename = decodeURIComponent(filename);
			} catch (e) {
				// If decoding fails, use the original filename
			}
			
			return filename || null;
		}

		return null; // Return null when extraction fails
	};

	const handleDownloadErrorReport = () => {
		// Check if any files are selected
		if (selectedFiles.length === 0) {
			toast.warning("Please select files to download reports.", {
				autoClose: 3000,
			});
			return;
		}

		// Get selected files details
		const selectedFilesData = files.filter(f => selectedFiles.includes(f.fileId));
		
		// Check if any selected file is not validated or doesn't have a report
		const filesWithoutReports = selectedFilesData.filter(f => f.reports !== true);
		if (filesWithoutReports.length > 0) {
			const fileNames = filesWithoutReports.map(f => f.fileName).join(', ');
			toast.error(`The following files are not validated or do not have reports: ${fileNames}. Please validate them first.`, {
				autoClose: 5000,
			});
			return;
		}

		// Get the file IDs of selected files that have reports (joined by semicolon)
		const fileIdsToDownload = selectedFilesData.map(f => f.fileId).join(';');

		setLoading({...loading, downloadError: true});
		apiService.exportFilesData(manuscriptId, fileIdsToDownload).then(res => {
			setLoading({...loading, downloadError: false});
			
			// TODO: Once backend adds Access-Control-Expose-Headers: Content-Disposition,
			// we can switch back to using the header exclusively
			// Extract filename from Content-Disposition header (currently not accessible due to CORS)
			const contentDisposition = res.headers?.['content-disposition'] || res.headers?.['Content-Disposition'];
			const headerFileName = extractFilenameFromContentDisposition(contentDisposition);
			
			// TEMPORARY: Use batch name for filename until backend exposes Content-Disposition header
			// Format: <Batch Name>_Report.xlsx
			const sanitizedBatchName = sanitizeBatchNameForFilename(manuscriptTitle);
			const fileName = headerFileName || `${sanitizedBatchName}_Report.xlsx`;
			
			fileDownload(res.data || res, fileName);
			toast.success("Validation reports XLSX file downloaded successfully", {
				autoClose: 3000,
			});
		}).catch(err => {
			setLoading({...loading, downloadError: false});
			toast.error(err?.response?.data?.message || "Failed to download validation reports XLSX", {
				autoClose: 3000,
			});
		});
	};

	const formatFileSize = (bytes) => {
		if (bytes === 0) return '0 Bytes';
		const k = 1024;
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
	};

	const getStatusBadge = (status, errorCount, warningCount) => {
		switch (status) {
			case 'uploaded':
				return <span className="badge badge-primary">Uploaded</span>;
			case 'validated':
				if (errorCount > 0) {
					return <span className="badge badge-danger">Has Errors</span>;
				} else if (warningCount > 0) {
					return <span className="badge badge-warning">Has Warnings</span>;
				} else {
					return <span className="badge badge-success">Validated</span>;
				}
			case 'error':
				return <span className="badge badge-danger">Validation Failed</span>;
			case 'pending':
				return <span className="badge badge-secondary">Pending</span>;
			default:
				return <span className="badge badge-light">Unknown</span>;
		}
	};

	// Initialize component
	useEffect(() => {
		console.log('🚀 SimplifiedManuscriptSubmission component mounted with manuscriptId:', manuscriptId);
		getManuscriptTitle();
		getJournalInfo(); // Get journal information
		getStepTwoFiles(); // Fetch files on component mount
	}, [manuscriptId]);

	return (
		<>
			<div className="my-2 py-2">
				<h3 className="">Manuscript Compliance Check</h3>
				<p className="mb-0"> Upload your manuscript files (single or multiple) to run formatting checks based on journal guidelines. You can upload DOCX, PDF, or ZIP files. After upload, you can validate individual files or run checks on all files at once.</p>
			</div>

			{/* Journal Guidelines Modal */}
			<Modal show={show} onHide={() => setShow(false)} size="lg">
				<Modal.Header closeButton>
					<Modal.Title as="h5" className="">
						<p className="m-0 p-0">{journal?.templateType === "Generic Guidelines" ? 'Generic Journal Guidelines' : 'Journal Submission Checklist'}</p>
						<p className="m-0 p-0 small">
							<a className={style.modalLink} href={journalDetails?.author_instructions} target="_blank">Instructions for authors</a>
						</p>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className={classNames(style.modalBody, "pt-2 px-1")}>
					{journalloader ? 
						<div className="d-flex justify-content-center align-items-center h-75"><CircleLoader /></div>
					:
						journalGuidelines ? 
							<Tabs id={key} activeKey={key} onSelect={(e) => setKey(e)}>
								{journalGuidelines.map((item, index) =>
									<Tab eventKey={index} title={item.name} key={index}>
										<ul style={{listStyle: "none"}}>
											{item.data.map((listData, listIndex) => 
												<li key={listIndex} className="my-2" dangerouslySetInnerHTML={{ __html: `${listData}` }}></li>
											)}
										</ul>
									</Tab>
								)}
							</Tabs>
						:
							<div className="d-flex justify-content-center align-items-center h-75 p-3">
								<p>Journal guidelines are not available for <strong className="px-2">{manuscriptTitle}</strong>!</p>
							</div> 
					}
				</Modal.Body>
			</Modal>

			{/* Delete Confirmation Modal */}
			<Modal show={deleteConfirmModal.visible} onHide={() => setDeleteConfirmModal({visible: false, fileId: null, fileName: '', isMultiple: false, fileList: []})}>
				<Modal.Header closeButton>
					<Modal.Title>
						{deleteConfirmModal.isMultiple ? 
							`Confirm Delete ${deleteConfirmModal.fileList.length} Files` : 
							'Confirm Delete'
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{deleteConfirmModal.isMultiple ? (
						<>
							<p>Are you sure you want to delete the following {deleteConfirmModal.fileList.length} files?</p>
							<ul className="list-unstyled">
								{deleteConfirmModal.fileList.map((file, index) => (
									<li key={file.fileId} className="mb-1">
										<FontAwesomeIcon icon={faFileAlt} className="text-muted mr-2" />
										{file.fileName}
									</li>
								))}
							</ul>
							<p className="text-muted">This action cannot be undone.</p>
						</>
					) : (
						<>
							<p>Are you sure you want to delete the file: <strong>{deleteConfirmModal.fileName}</strong>?</p>
							<p className="text-muted">This action cannot be undone.</p>
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-secondary" onClick={() => setDeleteConfirmModal({visible: false, fileId: null, fileName: '', isMultiple: false, fileList: []})}>
						Cancel
					</Button>
					<Button variant="danger" onClick={confirmDeleteFile} disabled={loading.delete || loading.deleteMultiple}>
						{loading.delete || loading.deleteMultiple ? 'Deleting...' : 'Delete'}
					</Button>
				</Modal.Footer>
			</Modal>

			{/* Upload Progress Modal */}
			<Modal show={uploadProgress.visible} onHide={handleCloseUploadModal} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>Upload Progress</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-3">
						<h6>Uploading {uploadProgress.files.length} file(s)</h6>
						<div className="progress mb-2">
							<div 
								className="progress-bar" 
								role="progressbar" 
								style={{ 
									width: `${(uploadProgress.files.filter(f => f.status === 'success' || f.status === 'failed' || f.status === 'cancelled').length / uploadProgress.files.length) * 100}%`,
									backgroundColor: '#7C2F8D'
								}}
							>
								{uploadProgress.files.filter(f => f.status === 'success' || f.status === 'failed' || f.status === 'cancelled').length} of {uploadProgress.files.length}
							</div>
						</div>
					</div>

					<div style={{ maxHeight: '400px', overflowY: 'auto' }}>
						<Table responsive hover>
							<thead className="bg-light sticky-top">
								<tr>
									<th width="50%">File Name</th>
									<th width="20%">Status</th>
									<th width="30%" className="text-right">Actions</th>
								</tr>
							</thead>
							<tbody>
								{uploadProgress.files.map((file) => (
									<tr key={file.id}>
										<td>
											<div className="d-flex align-items-center">
												<FontAwesomeIcon icon={faFileAlt} className="text-muted mr-2" />
												<span className="text-truncate">{file.name}</span>
											</div>
										</td>
										<td>
											{file.status === 'pending' && (
												<span className="badge badge-secondary">
													<FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />
													Pending
												</span>
											)}
											{file.status === 'uploading' && (
												<span className="badge badge-primary">
													<FontAwesomeIcon icon={faSpinner} className="mr-1 fa-spin" />
													Uploading
												</span>
											)}
											{file.status === 'success' && (
												<span className="badge badge-success">
													<FontAwesomeIcon icon={faCheck} className="mr-1" />
													Success
												</span>
											)}
											{file.status === 'failed' && (
												<span className="badge badge-danger">
													<FontAwesomeIcon icon={faXmark} className="mr-1" />
													Failed
												</span>
											)}
											{file.status === 'cancelled' && (
												<span className="badge badge-warning">
													<FontAwesomeIcon icon={faBan} className="mr-1" />
													Cancelled
												</span>
											)}
										</td>
										<td className="text-right">
											<div className="d-flex justify-content-end">
												{file.status === 'failed' && (
													<TooltipButton
														variant="outline-primary"
														size="sm"
														className={classNames("mr-1", style.outlinePrimaryButton)}
														onClick={() => handleRetryFile(file.id)}
														title="Retry upload"
													>
														<FontAwesomeIcon icon={faRotateRight} />
													</TooltipButton>
												)}
												{(file.status === 'pending' || file.status === 'uploading') && (
													<TooltipButton
														variant="outline-danger"
														size="sm"
														onClick={() => handleCancelFile(file.id)}
														title="Cancel upload"
													>
														<FontAwesomeIcon icon={faXmark} />
													</TooltipButton>
												)}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>

					{uploadProgress.files.some(f => f.status === 'failed') && (
						<div className="mt-3 p-2 bg-light rounded">
							<small className="text-muted">
								<FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />
								Some files failed to upload. Click the retry button next to failed files or use "Retry All Failed" below.
							</small>
						</div>
					)}
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex justify-content-between w-100">
						<div>
							{uploadProgress.files.some(f => f.status === 'failed') && (
								<Button
									variant="outline-primary"
									size="sm"
									onClick={handleRetryAllFailed}
									className={classNames("mr-2", style.outlinePrimaryButton)}
								>
									<FontAwesomeIcon icon={faRotateRight} className="mr-1" />
									Retry All Failed
								</Button>
							)}
							{uploadProgress.files.some(f => f.status === 'pending' || f.status === 'uploading') && (
								<Button
									variant="outline-danger"
									size="sm"
									onClick={handleCancelAllPending}
								>
									<FontAwesomeIcon icon={faBan} className="mr-1" />
									Cancel All Pending
								</Button>
							)}
						</div>
						<Button
							variant="primary"
							onClick={handleCloseUploadModal}
							disabled={!uploadProgress.files.every(f => f.status === 'success' || f.status === 'failed' || f.status === 'cancelled')}
							className={style.primaryButton}
						>
							Close
						</Button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* Max Files Warning Modal */}
			<Modal show={maxFilesWarningModal.visible} onHide={() => setMaxFilesWarningModal({visible: false, message: ''})}>
				<Modal.Header closeButton>
					<Modal.Title>Upload Limit Reached</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{maxFilesWarningModal.message}</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={() => setMaxFilesWarningModal({visible: false, message: ''})}>
						OK
					</Button>
				</Modal.Footer>
			</Modal>

			{/* Delete Progress Modal */}
			<Modal show={deleteProgress.visible} onHide={handleCloseDeleteModal} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>Delete Progress</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-3">
						<h6>Deleting {deleteProgress.files.length} file(s)</h6>
						<div className="progress mb-2">
							<div 
								className="progress-bar bg-danger" 
								role="progressbar" 
								style={{ 
									width: `${(deleteProgress.files.filter(f => f.status === 'success' || f.status === 'failed').length / deleteProgress.files.length) * 100}%`
								}}
							>
								{deleteProgress.files.filter(f => f.status === 'success' || f.status === 'failed').length} of {deleteProgress.files.length}
							</div>
						</div>
					</div>

					<div style={{ maxHeight: '400px', overflowY: 'auto' }}>
						<Table responsive hover>
							<thead className="bg-light sticky-top">
								<tr>
									<th width="50%">File Name</th>
									<th width="20%">Status</th>
									<th width="30%" className="text-right">Actions</th>
								</tr>
							</thead>
							<tbody>
								{deleteProgress.files.map((file) => (
									<tr key={file.id}>
										<td>
											<div className="d-flex align-items-center">
												<FontAwesomeIcon icon={faFileAlt} className="text-muted mr-2" />
												<span className="text-truncate">{file.name}</span>
											</div>
										</td>
										<td>
											{file.status === 'pending' && (
												<span className="badge badge-secondary">
													<FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />
													Pending
												</span>
											)}
											{file.status === 'deleting' && (
												<span className="badge badge-primary">
													<FontAwesomeIcon icon={faSpinner} className="mr-1 fa-spin" />
													Deleting
												</span>
											)}
											{file.status === 'success' && (
												<span className="badge badge-success">
													<FontAwesomeIcon icon={faCheck} className="mr-1" />
													Success
												</span>
											)}
											{file.status === 'failed' && (
												<span className="badge badge-danger">
													<FontAwesomeIcon icon={faXmark} className="mr-1" />
													Failed
												</span>
											)}
										</td>
										<td className="text-right">
											<div className="d-flex justify-content-end">
												{file.status === 'failed' && (
													<TooltipButton
														variant="outline-primary"
														size="sm"
														className={classNames("mr-1", style.outlinePrimaryButton)}
														onClick={() => handleRetryDeleteFile(file.id)}
														title="Retry delete"
													>
														<FontAwesomeIcon icon={faRotateRight} />
													</TooltipButton>
												)}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>

					{deleteProgress.files.some(f => f.status === 'failed') && (
						<div className="mt-3 p-2 bg-light rounded">
							<small className="text-muted">
								<FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />
								Some files failed to delete. Click the retry button next to failed files or use "Retry All Failed" below.
							</small>
						</div>
					)}
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex justify-content-between w-100">
						<div>
							{deleteProgress.files.some(f => f.status === 'failed') && (
								<Button
									variant="outline-primary"
									size="sm"
									onClick={handleRetryAllFailedDeletes}
									className={classNames("mr-2", style.outlinePrimaryButton)}
								>
									<FontAwesomeIcon icon={faRotateRight} className="mr-1" />
									Retry All Failed
								</Button>
							)}
						</div>
						<Button
							variant="primary"
							onClick={handleCloseDeleteModal}
							disabled={!deleteProgress.files.every(f => f.status === 'success' || f.status === 'failed')}
							className={style.primaryButton}
						>
							Close
						</Button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* Main Content */}
			<div className="bg-white rounded border mt-4 shadow-sm">
				<div className="sticky-div-1 bg-white d-flex flex-row z-index-10000 p-3 border-bottom">
					{/* <Col md={8} className="p-0">
						<h5 className="mb-1">File Management</h5>
						<p className="mb-0 text-muted">Upload, manage, and validate your manuscript files</p>
					</Col> */}
					<Col className="p-0">
						<div className="d-flex flex-row justify-content-between align-items-center">
							<div className="d-flex flex-column">
								<p className="m-0 small">Batch selected</p>
								<p className="font-weight-bold m-0 small text-truncate">
									{manuscriptTitle}
								</p>
							</div>
							<div className="d-flex flex-column text-right">
								<p className="m-0 small">Template selected</p>
								<p className="font-weight-bold m-0 small text-truncate">
									{journal?.journalTitle || "No journal selected"}
								</p>
							</div>
						</div>
					</Col>
				</div>

				<Row>
					<Col md={8} className="p-4">
						{/* File Upload Section */}
						<div className="mb-4">
							<h6>Upload Files</h6>
							<div 
								{...getRootProps()} 
								className={classNames(
									"border rounded p-4 text-center",
									isDragActive && !loading.upload && !loading.validate && !loading.downloadError && !loading.deleteMultiple && files.length < MAX_FILES_PER_BATCH ? style.dragDropBorderActive : "border-secondary",
									loading.upload || loading.validate || loading.downloadError || loading.deleteMultiple || files.length >= MAX_FILES_PER_BATCH ? "bg-light" : ""
								)}
								style={{ cursor: loading.upload || loading.validate || loading.downloadError || loading.deleteMultiple || files.length >= MAX_FILES_PER_BATCH ? 'not-allowed' : 'pointer' }}
							>
								<input {...getInputProps()} disabled={loading.upload || loading.validate || loading.downloadError || loading.deleteMultiple || files.length >= MAX_FILES_PER_BATCH} />
								{loading.upload || loading.validate || loading.downloadError || loading.deleteMultiple ? (
									<>
										<CircleLoader />
										<p className="mb-1 mt-3">
											{loading.upload && "Uploading files..."}
											{loading.validate && "Validating files..."}
											{loading.downloadError && "Downloading report..."}
											{loading.deleteMultiple && "Deleting files..."}
										</p>
										<p className="small text-muted mb-0">
											{loading.upload && "Please wait while your files are being processed"}
											{loading.validate && "Please wait while your files are being validated"}
											{loading.downloadError && "Please wait while your report is being generated"}
											{loading.deleteMultiple && "Please wait while your files are being deleted"}
										</p>
									</>
								) : files.length >= MAX_FILES_PER_BATCH ? (
									<>
										<FontAwesomeIcon icon={faExclamationTriangle} size="2x" className={classNames("mb-2", "text-warning")} />
										<p className="mb-1 text-warning">
											Maximum {MAX_FILES_PER_BATCH} files reached
										</p>
										<p className="small text-muted mb-0">Please delete files to upload more</p>
									</>
								) : (
									<>
										<FontAwesomeIcon icon={faCloudArrowUp} size="2x" className={classNames("mb-2", style.link)} />
										<p className="mb-1">
											{isDragActive ? 
												"Drop the files here..." : 
												"Drag & drop files here, or click to select files"
											}
										</p>
										<p className="small text-muted mb-0">Supported formats: DOCX, PDF, ZIP (Multiple files supported)</p>
									</>
								)}
							</div>
							
							<div className="mt-3">
								<input
									type="file"
									ref={inputFile}
									multiple={false}
									accept=".docx,.pdf,.zip"
									onChange={(e) => handleFileUpload(e.target.files)}
									style={{ display: 'none' }}
								/>
								{/* <Button 
									variant="outline-primary" 
									onClick={() => inputFile.current.click()}
									disabled={loading.upload}
								>
									<FontAwesomeIcon icon={faUpload} className="mr-2" />
									{loading.upload ? 'Uploading...' : 'Select Files'}
								</Button> */}
							</div>
						</div>

						{/* File List Section */}
						<div className="mb-4">
							<div className="d-flex justify-content-between align-items-center mb-3">
								<div className="d-flex align-items-center">
									<h6 className="mb-0">Uploaded Files ({files.length}/{MAX_FILES_PER_BATCH})</h6>
									{files.length >= MAX_FILES_PER_BATCH && (
										<span className="badge badge-warning ml-2">Limit Reached</span>
									)}
								</div>
								<Button
									onClick={handleDeleteSelectedFiles}
									disabled={loading.deleteMultiple || loading.validate || loading.downloadError || selectedFiles.length === 0}
									variant="outline-danger"
									size="sm"
									title="Delete all selected files"
								>
									<FontAwesomeIcon icon={faTrash} className="mr-1" />
									{loading.deleteMultiple ? 'Deleting...' : `Delete Selected (${selectedFiles.length})`}
								</Button>
							</div>

							{files.length === 0 ? (
								<div className="text-center py-5 text-muted">
									<FontAwesomeIcon icon={faFileAlt} size="3x" className="mb-3" />
									<p>No files uploaded yet</p>
								</div>
							) : (
								<Table responsive hover>
									<thead className="bg-light">
										<tr>
											<th width="5%">
												<Form.Check
													type="checkbox"
													checked={selectedFiles.length === files.length && files.length > 0}
													onChange={handleSelectAll}
													disabled={loading.validate || loading.downloadError || loading.deleteMultiple}
													style={{ marginLeft: 0 }}
													label=""
												/>
											</th>
											<th width="55%">File Name</th>
											<th width="15%">Status</th>
											<th width="15%" className="text-right">Actions</th>
										</tr>
									</thead>
									<tbody>
										{files.map((file, index) => (
											<tr key={file.fileId}>
												<td>
													<Form.Check
														type="checkbox"
														checked={selectedFiles.includes(file.fileId)}
														onChange={() => handleFileSelection(file.fileId)}
														disabled={loading.validate || loading.downloadError || loading.deleteMultiple}
													/>
												</td>
												<td>
													<div className="d-flex align-items-center">
														<FontAwesomeIcon icon={faFileAlt} className="text-muted mr-2" />
														<span className="text-truncate">{file.fileName}</span>
													</div>
												</td>
												<td>
													{file.reports === true ? (
														<span className="badge badge-success">
															<FontAwesomeIcon icon={faCheck} className="mr-1" />
															{file.message || 'Verified'}
														</span>
													) : file.validationType === 'error' && file.reports !== true ? (
														<span className="badge badge-danger">
															<FontAwesomeIcon icon={faXmark} className="mr-1" />
															{file.message || 'Validation Failed'}
														</span>
													) : (
														<span className="badge badge-secondary">
															{file.message || 'Uploaded'}
														</span>
													)}
												</td>
												<td className="text-right">
													<div className="d-flex justify-content-end">
														<Button
															size="sm"
															className={classNames("mr-1", style.outlineDangerButton)}
															onClick={() => handleDeleteFile(file.fileId)}
															title="Delete file"
															disabled={loading.downloadError || loading.validate || loading.delete || loading.deleteMultiple}
														>
															<FontAwesomeIcon icon={faTrash} />
														</Button>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							)}
						</div>
					</Col>

					{/* Action Panel */}
					<Col md={4} className="border-left p-4">
						<div className="sticky-top">
							<h6>Actions</h6>
							<div className="d-flex flex-column">
								<Button
									onClick={handleValidateSelected}
									disabled={loading.validate || loading.downloadError || loading.deleteMultiple || selectedFiles.length === 0}
									className={classNames("w-100 mb-3", style.primaryButton)}
								>
									{loading.validate ? 'Validating...' : `Validate Selected Files (${selectedFiles.length})`}
								</Button>

								<Button
									onClick={handleDownloadErrorReport}
									disabled={loading.downloadError || loading.validate || loading.deleteMultiple || selectedFiles.length === 0}
									className={classNames("w-100", style.outlinePrimaryButton)}
									title="Download validation reports as ZIP file for all validated files"
								>
									<FontAwesomeIcon icon={faDownload} className="mr-2" />
									{loading.downloadError ? 'Downloading...' : 'Download Error Report'}
								</Button>
							</div>

							{selectedFiles.length > 0 && (
								<div className="mt-3 p-3 bg-light rounded">
									<h6 className="small">Selected Files ({selectedFiles.length})</h6>
									<ul className="list-unstyled small mb-0">
										{selectedFiles.map(fileId => {
											const file = files.find(f => f.fileId === fileId);
											return (
												<li key={fileId} className="text-truncate">
													{file?.fileName}
												</li>
											);
										})}
									</ul>
								</div>
							)}
						</div>
					</Col>
				</Row>


			</div>
		</>
	)
}

export default SimplifiedManuscriptSubmission; 